import { useState, useEffect } from "react";
import { getParamInfo, getParamInfoNotLogin } from "api";

export default function useSysParam(code, notLogin = false) {
	const [param, setParam] = useState([]);

	const getParam = async () => {
		getParamInfo({ code }).then(async (res) => {
			setParam(res.data);
		});
	};

	const getParamNotLogin = async () => {
		getParamInfoNotLogin({ code }).then(async (res) => {
			setParam(res.data);
		});
	};

	useEffect(() => {
		if (code) {
			if (notLogin) {
				getParamNotLogin();
			} else {
				getParam();
			}
		}
	}, [code]);

	return {
		param,
		paramIntValue: param?.intValue,
		paramTextValue: param?.textValue,
	};
}
